'use client';

import { useState, useEffect } from 'react';

interface FooterProps {
  className?: string;
}

const Footer = ({ className = '' }: FooterProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentYear, setCurrentYear] = useState('2025');

  useEffect(() => {
    setIsHydrated(true);
    setCurrentYear(new Date().getFullYear().toString());
  }, []);

  if (!isHydrated) {
    return (
      <footer className={`bg-gradient-to-br from-[#0E3B3C] via-[#0E3B3C] to-[#1a5658] text-primary-foreground ${className}`}>
        <div className="max-w-7xl mx-auto px-8 py-16">
          <div className="h-48 bg-accent/20 animate-pulse"></div>
        </div>
      </footer>
    );
  }

  return (
    <footer className={`bg-gradient-to-br from-[#0E3B3C] via-[#0E3B3C] to-[#1a5658] text-primary-foreground py-16 px-8 border-t border-border ${className}`}>
      <div className="max-w-7xl mx-auto">
        {/* Single text block - left aligned, editorial style */}
        <div className="space-y-6 max-w-xl">
          {/* Firm Name */}
          <div className="text-2xl font-medium tracking-tight">
            ND LAW
          </div>
          
          {/* Subtitle */}
          <div className="text-base font-light opacity-90 leading-relaxed">
            International Arbitration & Strategic Dispute Resolution
          </div>
          
          {/* Contact Information */}
          <div className="space-y-2 text-sm font-light opacity-75 leading-relaxed">
            <div>62 Rue de Caumartin</div>
            <div>75009</div>
            <div>Paris</div>
            <div>France</div>
            <div className="pt-2">
              <a 
                href="mailto:contact@ndlaw.fr" 
                className="hover:opacity-100 transition-opacity"
              >
                contact@ndlaw.fr
              </a>
            </div>
          </div>
          
          {/* Copyright */}
          <div className="pt-4 text-xs font-light opacity-60">
            &copy; {currentYear} ND LAW. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;